export const ADDON_ACTIVITY = 0
export const PRE_GROUP_ACTIVITY = 1
export const ACTIVITY_LOCKED = 2
export const ACTIVITY_OPEN = 3
export const PRE_GROUP_ACTIVITY_EXPIRED = 4
export const SUBMIT_GROUP = 5
export const SELECT_GROUP = 6
export const CANT_SELECT_GROUP = 7
export const ACTIVITY_CLOSED = 8
export const ACTIVITY_EXPIRED = 9
export const REFRESH_PAGE = 10
export const LINEAR_ACTIVITY = 11

// Start Prakerja 2023
export const ABSENT_PREREQUISITE_RELATED_ACTIVITY = 12
export const ACTIVITY_PRESENCE_PARTICIPATION_UNDER_80 = 13
export const IN_PROGRESS_PREREQUISITE_RELATED_ACTIVITY = 14
// End Prakerja 2023

// Start Prakerja 2024
export const FACE_RECOGNITION_REQUIRED = 16
export const FACE_RECOGNITION_REQUEST_ERROR = 17
export const ONE_SELF_PACED_LEARNING_SESSION_A_DAY = 18
export const FACE_RECOGNITION_GENERATE_ERROR = 19
export const TUGAS_PRAKTIK_MANDIRI_INCOMPLETE_SUBMISSION = 20
export const FAILED_TO_SUBMIT_UNJUK_KETERAMPILAN = 21
export const FAILED_ANY_PREV_FACE_RECOGNITION = 22
export const TUGAS_PRAKTIK_MANDIRI_INCOMPLETE_FEEDBACK = 23

// Untuk Tatap Muka Mandiri (TPM) dan Unjuk Keterampilan (UK),
// kode lock result ini hanya di SET di Frontend.
export const QUIZ_TIME_LIMIT_EXCEEDED = 999
export const QUIZ_NEEDS_REMEDIAL = 998
// End Prakerja 2024

// custom lock untuk handle user memakai extension video
export const FORBIDDEN_VIDEO_EXTENSION = 403
